import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/dashboard"


export const Counts = async () => {
    return await axiosInstance(options).get(`${path}/counts`);
}

export const recentEventRegistration = async () => {
    return await axiosInstance(options).get(`${path}/event-registration/list`);
}

export const recentUserRegistration = async () => {
    return await axiosInstance(options).get(`${path}/user-registration/list`);
}
export const BookingsOverview = async (time_limit,custom_range) => {
    return await axiosInstance(options).get(`${path}/bookings-overview?time_limit=${time_limit}&custom_range=${custom_range}`);
}
export const RevenueOverview = async (time_limit,custom_range) => {
    return await axiosInstance(options).get(`${path}/revenue-overview?time_limit=${time_limit}&custom_range=${custom_range}`);
}

